import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type Store from '@ember-data/store'
import type RouterService from '@ember/routing/router-service'
import type Teacher from 'teacher-ui-client/models/teacher'

interface Params extends Record<string, unknown> {
  teacher_id: string
}

export default class ManageTeachersTeacherRoute extends Route {
  @service store!: Store

  @service router!: RouterService

  async model({ teacher_id: teacherId }: Params) {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const teacher = this.store.peekRecord<Teacher>('teacher', teacherId)

    if (teacher) {
      return {
        teacher,
        subscriptionType,
      }
    } else {
      return this.router.replaceWith('manage.teachers')
    }
  }
}
